import { HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, MonoTypeOperatorFunction, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { LoginService } from '../services/login.service';

const handle401 = (loginService: LoginService): MonoTypeOperatorFunction<HttpEvent<unknown>> =>
  tap({
    error: (err: { status: number }) => {
      if (err.status === 401) {
        localStorage.removeItem('user_access_token');
        loginService.redirectToLogin();
      }
    },
  });

export const userTokenInterceptor: HttpInterceptorFn = (request, next) => {
  const loginService: LoginService = inject(LoginService);

  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return next(request);
  }

  const token: string | null = localStorage.getItem('user_access_token');

  if (!token || !request.url.includes(environment.apiUrl)) {
    return next(request);
  }

  const expiresInSeconds: number | null = loginService.decodeTokenExpiration(token);
  if (expiresInSeconds !== null) {
    loginService.tokenExpiresIn.set(expiresInSeconds);
  }

  if (expiresInSeconds !== null && expiresInSeconds <= 0) {
    localStorage.removeItem('user_access_token');
    loginService.redirectToLogin();
    return EMPTY;
  }

  return next(request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })).pipe(
    handle401(loginService),
  );
};
